import type { CategoryConfig, CategoryQuestionNode } from "./category";

export function hasQuestionTree(config?: CategoryConfig | null): boolean {
  return Array.isArray(config?.questionTree) && (config?.questionTree?.length ?? 0) > 0;
}

export function isQuestionBranch(node?: CategoryQuestionNode | null): boolean {
  return Array.isArray(node?.children) && (node?.children?.length ?? 0) > 0;
}
